export default __webpack_public_path__ + "static/media/card7.47d6ce6f.jpg";